import { MaybeIsVariant } from './MaybeIsVariant';
import { findEarliestRenewalSubscription } from 'growth-feature-usage-components/utils/subscriptions';
import { useFetchFeatureLoss } from 'growth-feature-usage-data/hooks/featureLoss';
import { jsx as _jsx } from "react/jsx-runtime";
export const MaybeHasFeatureLoss = ({
  featureLimitName,
  logExposure,
  treatments,
  upcomingRenewalSubscriptions,
  allSubscriptions
}) => {
  const productApiNames = upcomingRenewalSubscriptions.map(({
    productApiName
  }) => productApiName);
  const allProductApiNames = allSubscriptions.map(({
    productApiName
  }) => productApiName);
  const {
    portalFeatureLoss,
    loading
  } = useFetchFeatureLoss(productApiNames, 'starter', 'free', {
    allProductApiNames
  });
  const lostFeature = portalFeatureLoss.filter(featureLoss => featureLoss.limitName === featureLimitName)[0];
  if (loading) {
    return null;
  }
  if (!lostFeature) {
    return null;
  }
  const {
    subscriptionRenewalDate,
    subscriptionId,
    productApiName
  } = findEarliestRenewalSubscription(upcomingRenewalSubscriptions, lostFeature.productApiNames);
  return /*#__PURE__*/_jsx(MaybeIsVariant, {
    featureLimitName: featureLimitName,
    subscriptionRenewalDate: subscriptionRenewalDate,
    subscriptionId: subscriptionId,
    logExposure: logExposure,
    treatments: treatments,
    lostFeature: lostFeature,
    productApiName: productApiName
  });
};